import React from "react";
import "../styles/Notifications.css";

const Notifications = () => {
  const notifications = [
    {
      id: 1,
      title: "New Profile Matches Available",
      message: "3 new groom profiles match your search criteria and preferences.",
      type: "match",
      time: "2 hours ago",
      unread: true
    },
    {
      id: 2,
      title: "Membership Expiry Reminder",
      message: "Your Gold plan expires in 5 days. Renew now to maintain uninterrupted access.",
      type: "reminder",
      time: "1 day ago",
      unread: true
    },
    {
      id: 3,
      title: "Platform Feature Update",
      message: "Enhanced profile filtering with advanced education and location criteria now available.",
      type: "update",
      time: "3 days ago",
      unread: false
    },
    {
      id: 4,
      title: "Profile Visibility Report",
      message: "Your profile was viewed by 5 potential matches in the last 24 hours.",
      type: "analytics",
      time: "Just now",
      unread: true
    }
  ];

  const getNotificationType = (type) => {
    switch (type) {
      case "match":
        return "Match Alert";
      case "reminder":
        return "Membership";
      case "update":
        return "Platform Update";
      case "analytics":
        return "Profile Analytics";
      default:
        return "Notification";
    }
  };

  return (
    <div className="notifications-container">
      <div className="notifications-header">
        <h2 className="notifications-title">Notifications</h2>
        <p className="notifications-subtitle">
          Stay informed about your membership, profile matches, and platform updates.
        </p>
      </div>

      

      <div className="notifications-list">
        {notifications.map((notification) => (
          <div 
            key={notification.id} 
            className={`notification-card ${notification.unread ? 'unread' : ''}`}
          >
            <div className="notification-indicator"></div>
            <div className="notification-content">
              <div className="notification-header">
                <h4 className="notification-title">{notification.title}</h4>
                <span className="notification-time">{notification.time}</span>
              </div>
              <p className="notification-message">{notification.message}</p>
              <div className="notification-footer">
                <span className="notification-type">{getNotificationType(notification.type)}</span>
                {notification.unread && <span className="unread-badge">New</span>}
              </div>
            </div>
          </div>
        ))}
      </div>

      
    </div>
  );
};

export default Notifications;